import RequireRoutePermit from "RequireRoutePermit"

import React from "react"
import { Route, Navigate } from "react-router-dom"

const ProfileWrapper = React.lazy(
  () => import("../pages/dashboard/people/employee/Profile")
)
const PayAndJob = React.lazy(
  () => import("../pages/dashboard/people/employee/job-and-pay/JobAndPay")
)
const Personal = React.lazy(
  () => import("../pages/dashboard/people/employee/personal/Personal")
)
const Request = React.lazy(
  () => import("../pages/dashboard/people/employee/requests/Requests")
)
const LeaveBalances = React.lazy(
  () =>
    import("pages/dashboard/people/employee/requests/components/LeaveBalances")
)

const Documents = React.lazy(
  () => import("../pages/dashboard/people/employee/documents/Documents")
)

const Benefit = React.lazy(
  () => import("../pages/dashboard/people/employee/benefits/Benefit")
)

const Assets = React.lazy(
  () => import("../pages/dashboard/people/employee/assets/Assets")
)

const Tasks = React.lazy(
  () => import("../pages/dashboard/people/employee/tasks/Task")
)

const Performance = React.lazy(
  () => import("../pages/dashboard/people/employee/performance/Performance")
)

const Disciplinary = React.lazy(
  () => import("../pages/dashboard/people/employee/disciplinary/Disciplinary")
)

const Notes = React.lazy(
  () => import("../pages/dashboard/people/employee/notes/Notes")
)
const EmployeeLogs = React.lazy(
  () => import("../pages/dashboard/people/employee/logs/EmployeeLogs")
)

const ProfileRoutes = () => {
  return (
    <>
      <Route
        path=""
        element={<ProfileWrapper />}
      >
        <Route
          path="job-and-pay"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_compensation_details",
                "can_view_employee_details",
              ]}
            >
              <PayAndJob />
            </RequireRoutePermit>
          }
        />
        <Route
          path="personal"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_details",
                "can_view_employee_details",
              ]}
            >
              <Personal />
            </RequireRoutePermit>
          }
        />
        <Route
          path="requests"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_requests",
                "can_view_employee_details",
              ]}
            >
              <Request />
            </RequireRoutePermit>
          }
        />

        <Route
          path="documents"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_documents",
                "can_view_employee_details",
              ]}
            >
              <Documents />
            </RequireRoutePermit>
          }
        />
        <Route
          path="benefits"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_benefits",
                "can_view_employee_details",
              ]}
            >
              <Benefit />
            </RequireRoutePermit>
          }
        />
        <Route
          path="assets"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_assets",
                "can_view_employee_details",
              ]}
            >
              <Assets />
            </RequireRoutePermit>
          }
        />
        <Route
          path="tasks"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_tasks",
                "can_view_employee_details",
              ]}
            >
              <Tasks />
            </RequireRoutePermit>
          }
        />
        <Route
          path="performance"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_details",
                "can_view_employee_details",
              ]}
            >
              <Performance />
            </RequireRoutePermit>
          }
        />

        <Route
          path="disciplinary"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_disciplinary_details",
                "can_view_employee_details",
              ]}
            >
              <Disciplinary />
            </RequireRoutePermit>
          }
        />

        <Route
          path="notes"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_notes",
                "can_view_employee_details",
              ]}
            >
              <Notes />
            </RequireRoutePermit>
          }
        />
        <Route
          path="logs"
          element={
            <RequireRoutePermit
              allowedPermissions={[
                "can_view_personal_logs",
                "can_view_employee_details",
              ]}
            >
              <EmployeeLogs />
            </RequireRoutePermit>
          }
        />
      </Route>
      <Route
        path="/dashboard/employee/:employeeKey/requests/leave-balances"
        element={
          <RequireRoutePermit
            allowedPermissions={[
              "can_view_personal_requests",
              "can_view_employee_details",
            ]}
          >
            <LeaveBalances />
          </RequireRoutePermit>
        }
      />
    </>
  )
}

export default ProfileRoutes
